
import api from './axiosConfig';
const url = '/api/revisiones/clientes';

/**
 * Buscar a un cliente del taller por su rut
 * @param {*} clienteRut Rut del cliente
 * @returns 
 */
async function buscarPorRut(clienteRut) {
  try {
    const response = await api.get(
      `${url}/buscar`, { 
      params: { rut: clienteRut }
    });
    return response.data?.clientes || [];
  } catch (error) {
    throw error.response?.data.msg || error.message || error;
  }
}

const clienteService = { buscarPorRut };
export default clienteService;